export const ProgressBar = ({percentage}) => {
    return (<div className="progress-container">
        <div className="progress-bar">
            <div className="progress-bar-fill" style={{width: `${percentage}%`, background: `#FFFFFF 0% 0% no-repeat padding-box`}}>
            </div>
        </div>
    </div>);
};